export const UserSettingModel = Symbol.for('UserSettingModel');
